export const PRODUCT_NAME = "SAT-001";

/**
 * 환자·보호자에게 노출되는 제품명.
 *
 * i18n 문자열에서는 {{APP_PRODUCT_NAME}} 으로 참조한다.
 * (i18next interpolation.defaultVariables 에 등록되어 있어 별도 인자 전달이 필요 없다)
 */
export const APP_PRODUCT_NAME = "MyoHabit™";

// MARK:- Secure Storage Key
export const AES_KEY = "aesKey";

// MARK:- RootPath
export const ROOT_PATH = "/";
export const LOGIN_PATH = "/login";
export const HOME_PATH = "/home";
export const ADMIN_HOME_PATH = "/admin/home";
export const MY_INFO_CHANGE_PD_PATH = "/home/password-change";
export const ADMIN_MY_INFO_CHANGE_PD_PATH = "/admin/home/password-change";
export const FIND_PASSWORD_PATH = "/find-password";
export const SELF_SIGNUP_PATH = "/self-signup";
export const APP_ACCOUNT_SETTING_PATH = "/app-account-setting";
export const INIT_PASSWORD_PATH = "/init-password";

//MARK:- Password Change Type
export enum PasswordChangeType {
  INITIAL = "initial", // 초기 패스워드
  EXPIRED = "expired", // 패스워드 만료
}

export const PASSWORD_CHANGE_TYPE_PARAM = "passwordChangeType";

//MARK:- Calendar
const today = new Date();
const minBirthDate = new Date();
minBirthDate.setFullYear(today.getFullYear() - 13);
export const MIN_BIRTH_DATE_BEFORE_13_YEARS = minBirthDate;
export const MAX_BIRTH_DATE_TODAY = new Date();
export const UNLIMITED_DATE = new Date("9999-12-31");

//MARK:- FetchApiClient (암호화 URL 판별: 경로 세그먼트 문자열만 허용)
export const FETCH_API_CLIENT_ENCRYPT_URL_STR = "s";

// MARK:- Support Country Code
export const SUPPORT_COUNTRY_CODE = ["kr", "us", "jp", "vn", "hk"];

// MARK:- Auth Code timeout
export const AUTH_CODE_TIMEOUT = 60; // 60초

// MARK:- Adherence
export const GOOD_ADHERENCE_THRESHOLD = 80;

// MARK:- Breadcrumb
// BREADCRUMB 관련 상수 및 매퍼 정의 (헤더의 경로 네비게이션에 사용)
// 순서를 변경할때 주의를 요합니다.
//
// * 패턴 매칭 예시:
// "/home/patient/123/add-treatment" → "/home/patient/*/add-treatment"
// "/home/patient/123" → "/home/patient/*"
export const BREADCRUMB_PATH_MAPPER = {
  "/home": "breadcrumbs.home",
  "/info": "breadcrumbs.profile",
  "/home/patient": "breadcrumbs.patientList",
  "/home/password-change": "breadcrumbs.passwordChange",
  "/home/add/patient": "breadcrumbs.addPatient",
  "/home/patient/*": "breadcrumbs.patientDetail",
  "/home/patient/*/add-treatment": "breadcrumbs.addTreatment",
  "/home/patient/*/*": "breadcrumbs.treatmentProgress",
  "/home/medical-device-info": "breadcrumbs.medicalDeviceInfo",
  "/home/action-logs": "breadcrumbs.actionLogs",
  "/admin/home": "breadcrumbs.adminHome",
  "/admin/home/medical-device-info": "breadcrumbs.medicalDeviceInfo",
  "/admin/home/doctors": "breadcrumbs.adminDoctors",
  "/admin/home/doctors/*": "breadcrumbs.doctorDetail",
  "/admin/home/hospitals": "breadcrumbs.adminHospitals",
  "/admin/home/hospitals/add": "breadcrumbs.adminAddHospital",
  "/admin/home/patients": "breadcrumbs.adminPatients",
  "/admin/home/patients/*": "breadcrumbs.patientDetail",
  "/admin/home/patients/*/*": "breadcrumbs.treatmentProgress",
  "/admin/home/logs": "breadcrumbs.adminLogs",
  "/admin/home/action-logs": "breadcrumbs.adminActionLogs",
  "/admin/home/add-doctor": "breadcrumbs.adminAddDoctor",
  "/admin/home/notices": "breadcrumbs.adminNotices",
  "/admin/home/notices/add": "breadcrumbs.adminAddNotice",
  "/admin/home/notices/edit": "breadcrumbs.adminEditNotice",
  "/admin/home/notices/detail": "breadcrumbs.noticeDetail",
  "/admin/home/password-change": "breadcrumbs.passwordChange",
  "/medical-device-info": "breadcrumbs.medicalDeviceInfo",
};

// MARK:- Exclude Header& Footer Path
export const EXCLUDE_HEADER_PATH = [ROOT_PATH];
export const EXCLUDE_BREADCRUMB_PATH = [
  HOME_PATH,
  MY_INFO_CHANGE_PD_PATH,
  ADMIN_MY_INFO_CHANGE_PD_PATH,
  FIND_PASSWORD_PATH,
  ADMIN_HOME_PATH,
  INIT_PASSWORD_PATH,
];
export const EXCLUDE_FOOTER_PATH = [SELF_SIGNUP_PATH, APP_ACCOUNT_SETTING_PATH];

//MAKR:- Light Estimation MAX count
export const LIGHT_ESTIMATION_MAX_COUNT = 3;

//MARK:- UI Constants
export const MAIN_SEARCH_BAR_HEIGHT = "3.5rem";
export const SUB_SEARCH_BAR_HEIGHT = "3rem";
export const DEFAULT_TABLE_HOVER_COLOR = "var(--color-warm-grey-96)";
